import * as types from "./actionTypes";

const initialState = {
  isMenuOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_MENU:
      return {
        ...state,
        isMenuOpen: !state.isMenuOpen,
      };

    default:
      return state;
  }
};
